if (!customElements.get("td-accordion-wrapper")) {
  class TdAccordion extends HTMLElement {
    constructor() {
      super();
      this.options = this.dataset.options;
      this.onlyOneActive = false;
    }

    connectedCallback() {
      this.items = this.querySelectorAll(".td-accordion__item");
      this.bindEvents();
    }

    bindEvents() {
      const el = this;
      this.items.forEach(function (item) {
        const toggle = item.querySelector(".td-accordion__toggle");
        if (toggle) {
          toggle.addEventListener("click", function (event) {
            event.preventDefault();
            el.toggle(item.dataset.item);
          });
          if (item.dataset.open) {
            el.toggle(item.dataset.item);
          }
        }

        const toggleNext = item.querySelector(".td-accordion__toggle-next");
        if (toggleNext) {
          toggleNext.addEventListener("click", function (event) {
            event.preventDefault(), el.toggle(parseInt(item.dataset.item) + 1);
          });
        }
      });
    }

    toggle(currentItem) {
      const el = this;
      this.items.forEach(function (item) {
        const content = item.querySelector(".td-accordion__content");
        if (!content) return;
        if (item.dataset.item == currentItem) {
          if (item.classList.contains("is-active")) {
            content.style.maxHeight = null;
          } else {
            // Temporarily remove max-height to get accurate scrollHeight
            content.style.maxHeight = 'none';
            const height = content.scrollHeight;
            content.style.maxHeight = '0';
            
            // Use requestAnimationFrame for smooth transition
            requestAnimationFrame(function() {
              content.style.maxHeight = height + "px";
            });
          }
          item.classList.toggle("is-active");
        } else if (el.onlyOneActive) {
          item.classList.remove("is-active");
          content.style.maxHeight = null;
        }
      });
    }
  }

  customElements.define("td-accordion-wrapper", TdAccordion);
}
